import { createSelector } from 'reselect';

export const selectParkingsSlice = state => state.parkings;

export const selectParkings = createSelector(
  selectParkingsSlice,
  slice => slice.parkings
);
export const parkingsLoaded = createSelector(
  selectParkingsSlice,
  slice => slice.parkingsLoaded
);
export const selectActiveParking = createSelector(
  selectParkingsSlice,
  slice => slice.activeParking
);

export const parkingsMeta = createSelector(
  selectParkingsSlice,
  slice => slice.meta
);
export const parkingsFilters = createSelector(
  selectParkingsSlice,
  slice => slice.filters
);
export const parkingsEvent = createSelector(
  selectParkingsSlice,
  slice => slice.eventId
);

export const parkingCreating = createSelector(
  selectParkingsSlice,
  slice => slice.isCreating
);
export const parkingsUpdating = createSelector(
  selectParkingsSlice,
  slice => slice.isUpdating
);
export const parkingsDeleting = createSelector(
  selectParkingsSlice,
  slice => slice.isDeleting
);
export const parkingsErrors = createSelector(
  selectParkingsSlice,
  slice => slice.errors
);
